<!-- * Find and use type of control -->
<ng-container *ngIf="field.controlType === 'input'">
  <app-input [options]="field.options" [customFormGroup]="mainForm"></app-input>
</ng-container>
<ng-container *ngIf="field.controlType === 'input-number'">
  <app-input-number [options]="field.options" [customFormGroup]="mainForm"></app-input-number>
</ng-container>
<ng-container *ngIf="field.controlType === 'checkbox'">
  <app-checkbox
    [options]="field.options"
    [customFormGroup]="mainForm"
  ></app-checkbox>
</ng-container>
<ng-container *ngIf="field.controlType === 'toggle'">
  <app-toggle
    [options]="field.options"
    [customFormGroup]="mainForm"
  ></app-toggle>
</ng-container>
<ng-container *ngIf="field.controlType === 'chips'">
  <app-chips [options]="field.options" [customFormGroup]="mainForm"></app-chips>
</ng-container>
<ng-container *ngIf="field.controlType === 'colorpicker'">
  <app-color-picker
    [options]="field.options"
    [customFormGroup]="mainForm"
  ></app-color-picker>
</ng-container>
<ng-container *ngIf="field.controlType === 'datepicker'">
  <app-datepicker
    [options]="field.options"
    [customFormGroup]="mainForm"
  ></app-datepicker>
</ng-container>
<ng-container *ngIf="field.controlType === 'input-password'">
  <app-input-password [options]="field.options"></app-input-password>
</ng-container>
<ng-container *ngIf="field.controlType === 'rich-editor'">
  <app-rich-editor [options]="field.options"></app-rich-editor>
</ng-container>
<ng-container *ngIf="field.controlType === 'textarea'">
  <app-textarea [options]="field.options"></app-textarea>
</ng-container>
<ng-container *ngIf="field.controlType === 'dropdown'">
  <app-dropdown
    [options]="field.options"
    [customFormGroup]="mainForm"
  ></app-dropdown>
</ng-container>
<ng-container *ngIf="field.controlType === 'multiselect'">
  <app-multi-select
    [options]="field.options"
    [customFormGroup]="mainForm"
  ></app-multi-select>
</ng-container>
